module.exports = __webpack_public_path__ + "static/media/icon_product_store.2c26cc3a.svg";